import { omitBy } from "lodash";

const sanitizeValues = (values) =>
    omitBy(values, (value) => typeof value === "string" && !value.length);

export default { sanitizeValues };
